import React from "react";
import "./style.scss";
import Logo from "../../components/SvgIcons/Logo";
import { Link } from "react-router-dom";
import AdminNavigation from "../AdminNavigation";
export default function AdminHeader() {
  return (
    <div className="admin-navigation">
      <header className="header-main">
        <div className="admin-container">
          <div className="header-first">
            <div className="header-logo">
              <Link to="/dashboard">
                <Logo />
              </Link>
            </div>
            <Link to="#" className="user">
              <span>Morgan Charles</span>
              <img src="../images/admin-pictures/user.png" alt="user" />
            </Link>
          </div>
        </div>
      </header>
      <AdminNavigation />
    </div>
  );
}
